function ChartTooltip({ active, payload, label, variant = 'tps' }) {
  if (!active || !payload?.length) {
    return null;
  }

  const unit = variant === 'ping' ? 'ms' : 'TPS';

  return (
    <div className="chart-tooltip" role="tooltip">
      <p className="chart-tooltip__time">{label}</p>
      <ul className="chart-tooltip__list">
        {payload
          .filter((entry) => entry.value != null)
          .map((entry) => (
            <li key={entry.dataKey} className="chart-tooltip__row">
              <span className="chart-tooltip__dot" style={{ backgroundColor: entry.color }} aria-hidden />
              <span className="chart-tooltip__name">{entry.name}</span>
              <span className="chart-tooltip__value">
                {Number(entry.value).toLocaleString(undefined, { maximumFractionDigits: 2 })}{' '}
                <span className="chart-tooltip__unit">{unit}</span>
              </span>
            </li>
          ))}
      </ul>
    </div>
  );
}

export default ChartTooltip;
